<template>
    <v-row justify="center">
        <v-dialog v-model="this.showDialog" fullscreen hide-overlay transition="dialog-bottom-transition">
            <v-card height="fill">
                <v-card-title class="headline pt-1 pr-1 custom-card-header">
                    Route Details
                    <v-spacer></v-spacer>
                    <v-btn icon dark @click="toggle"><v-icon>close</v-icon></v-btn>
                </v-card-title>
                <v-container fluid class="display-flex no-bottom-pad">
                    <v-flex xs6>
                        <v-card flat class="ma-3">
                            <h1 class="mb-3">Route Information</h1>
                            <v-row>
                                <v-flex xs6>
                                    <v-text-field class="ma-2" outlined label="Name/Number" v-model="route.name"></v-text-field>
                                </v-flex>
                                <v-flex xs6>
                                    <v-text-field v-model="route.color" label="Color" hide-details class="ma-2" outlined>
                                        <template v-slot:append>
                                            <v-menu v-model="colorPickerMenu" top nudge-bottom="105" nudge-left="16" :close-on-content-click="false">
                                                <template v-slot:activator="{ on }">
                                                    <div :style="swatchStyle" v-on="on" />
                                                </template>
                                                <v-card>
                                                    <v-card-text class="pa-0">
                                                        <v-color-picker class="ma-2" :swatches="colorPickerColors" v-model="route.color" show-swatches></v-color-picker>
                                                    </v-card-text>
                                                </v-card>
                                            </v-menu>
                                        </template>
                                    </v-text-field>
                                </v-flex>
                            </v-row>
                            <v-tabs v-model="tab" grow show-arrows>
                                <v-tabs-slider></v-tabs-slider>
                                <v-tab href="#tasks">Tasks</v-tab>
                                <v-tab href="#crew">Crew</v-tab>
                            </v-tabs>
                            <v-tabs-items v-model="tab">
                                <v-tab-item value="tasks">
                                    <v-data-table
                                        :headers="headers"
                                        :items="route.jobTasks"
                                        :options="tableOptions"
                                        sort-by="Order"
                                        class="elevation-1">
                                        <template v-slot:body="{ items }">
                                            <tbody>
                                            <tr v-for="item in items" :key="item.id" @click="selectTask(item)"  v-bind:class="selected && item.id === selected.id || item.id === selectedItem.id ? 'selectedRow' : ''">
                                                <td>{{ item.iconId }}</td>
                                                <td>{{ item.address }}</td>
                                                <td> <v-chip label @click="toggleQuickStatusModal"> {{ item.status }} </v-chip></td>
                                                <td> <v-chip v-for="string in item.tagsList" :key="string" class="ma-1" small> {{ string }} </v-chip> </td>
                                                <td>
                                                    <v-tooltip top>
                                                        <template v-slot:activator="{ on }">
                                                            <v-icon
                                                                v-on="on"
                                                                color="orange"
                                                                @click="showTaskDetailsDialog(item)">
                                                                mdi-square-edit-outline
                                                            </v-icon>
                                                        </template>
                                                        <span>Edit Task</span>
                                                    </v-tooltip>
                                                    <v-tooltip top>
                                                        <template v-slot:activator="{ on }">
                                                            <v-icon
                                                                v-on="on"
                                                                color="red"
                                                                @click="showRemoveTaskDialog(item)">
                                                                mdi-delete
                                                            </v-icon>
                                                        </template>
                                                        <span>Remove Task From Route</span>
                                                    </v-tooltip>
                                                </td>
                                            </tr>
                                            </tbody>
                                        </template>
                                    </v-data-table>
                                    <br />
                                    <v-combobox
                                        label="Add Task"
                                        :items="unassignedTasks"
                                        multiple
                                        v-model="tasksToAdd"
                                        outlined
                                        clearable
                                        chips>
                                    </v-combobox>
                                </v-tab-item>
                                <v-tab-item value="crew">
                                    <v-data-table
                                        :headers="userHeaders"
                                        :items="route.userRoutes"
                                        item-key="name"
                                        :options="tableOptions"
                                        class="elevation-1">
                                        <template v-slot:item.action="{ item }">
                                            <v-tooltip top>
                                                <template v-slot:activator="{ on }">
                                                    <v-icon
                                                        v-on="on"
                                                        class="mr-2"
                                                        color="red"
                                                        @click="showRemoveUserDialog(item)">
                                                        mdi-delete
                                                    </v-icon>
                                                </template>
                                                <span>Remove User</span>
                                            </v-tooltip>
                                        </template>
                                    </v-data-table>
                                    <br />
                                    <v-combobox
                                        label="Add User"
                                        :items="usersForDropDown"
                                        item-text="user.displayName"
                                        item-value="id"
                                        multiple
                                        hide-no-data
                                        v-model="usersToAdd"
                                        outlined
                                        chips
                                        clearable>
                                    </v-combobox>
                                </v-tab-item>
                            </v-tabs-items>
                            <div v-if="disabled" class="text-center">
                                Saving<br />
                                <v-progress-circular
                                    indeterminate
                                    color="primary"
                                    v-if="disabled"
                                ></v-progress-circular>
                            </div>
                            <div v-if="this.showNameError" class="text-center error--text mt-3 mb-5 success-message">Name cannot be empty</div>
                            <div class="bottom-buttons">
                                <v-btn v-if="actionType === 'update'" color="primary" large class="ma-2" :disabled="disabled" @click="save">Update</v-btn>
                                <v-btn v-if="actionType === 'create'" color="primary" large class="ma-2" :disabled="disabled" @click="save">Create</v-btn>
                                <v-btn color="primary" outlined large class="ma-2" @click="toggle">Close</v-btn>
                            </div>
                        </v-card>
                    </v-flex>
                    <v-flex xs6 class="ma-3">
                        <route-details-map-view v-on:selectTask="selectTask"></route-details-map-view>
                    </v-flex>
                    <status-update :show-dialog="statusUpdateDialog" :job-task="selected" :toggle="toggleQuickStatusModal"></status-update>
                </v-container>
            </v-card>
        </v-dialog>
    </v-row>
</template>
<script>
    import { mapGetters, mapActions } from 'vuex'
    import RouteDetailsMapView from '../../components/routes/RouteDetailsMap'
    import StatusUpdate from "@/components/routes/StatusUpdate"
    export default {
        name: 'route-details',
        components: {
            RouteDetailsMapView,
            StatusUpdate
        },
        props: {
            showDialog: {
                type: Boolean,
                required: true
            },
            toggle: {
                type: Function,
                required: true
            },
            showRemoveTaskDialog: {
                type: Function,
                required: true
            },
            showTaskDetailsDialog: {
                type: Function,
                required: true
            },
            showRemoveUserDialog: {
                type: Function,
                required: true
            },
            actionType: {
                type: String,
                required: true
            }
        },
        data() {
            return {
                tab: 'tasks',
                disabled: false,
                createTaskDialog: false,
                createRouteDialog: false,
                statusUpdateDialog: false,
                tasksToAdd: [],
                usersToAdd: [],
                selectedJobTask: null,
                colorPickerMenu: false,
                showNameError: false,
                selectedItem: {
                    id: -1
                },
                tableOptions: {
                    itemsPerPage: 10
                }
            }
        },
        methods: {
            ...mapActions({
                updateTask: 'jobTasks/update',
                updateRoute: 'routes/update',
                addUserToRoute: 'routes/addUserToRoute',
                getRoute: 'routes/getIsolatedRoute',
                getAllRoutes: 'routes/getAll',
                createRoute: 'routes/create',
                getTask: 'jobTasks/getById',
                getNumberAndAddress: 'jobTasks/getNumberAndAddress',
                assignTask: 'jobTasks/assignTask',
            }),
            async save () {
                if(!this.route.name){
                    this.showNameError = true
                    return
                } else {
                    this.showNameError = false
                }
                this.disabled = true
                let routeToSave = {
                    color: this.route.color,
                    name: this.route.name,
                }
                if (this.actionType === 'create') {
                    let newRouteId = await this.createRoute(routeToSave)
                    if (this.tasksToAdd.length > 0) {
                        for (const task of this.tasksToAdd) {
                            if(task.value){
                                this.assignTask({taskId: task.value, routeId: newRouteId})
                            }
                        }
                        this.tasksToAdd = []
                    }
                    if (this.usersToAdd.length > 0) {
                        for (const u of this.usersToAdd) {
                            let userRoute = { userId: u.user.id, routeId: newRouteId }
                            await this.addUserToRoute(userRoute)
                        }
                        this.usersToAdd = []
                    }
                    await this.getRoute(newRouteId)
                    await this.getAllRoutes()
                    this.disabled = false
                    await this.toggle()
                } else {
                    if (this.tasksToAdd.length > 0) {
                        for (const task of this.tasksToAdd) {
                            if(this.route.id)
                                this.assignTask({taskId: task.value, routeId: this.route.id})
                        }
                        this.tasksToAdd = []
                    }
                    if (this.usersToAdd.length > 0) {
                        for (const u of this.usersToAdd) {
                            let userRoute = {userId: u.user.id, routeId: this.route.id}
                            await this.addUserToRoute(userRoute)
                        }
                        this.usersToAdd = []
                    }
                    routeToSave.id = this.route.id
                    routeToSave.archived = this.route.archived
                    await this.updateRoute(routeToSave)
                    await this.getRoute(this.route.id)
                    this.disabled = false
                }
            },
            removeTaskFromSelect (task) {
                this.tasksToAdd.splice(task)
            },
            removeUserFromSelect (user) {
                this.usersToAdd.splice(user)
            },
            async removeTaskFromRoute (task) {
                this.selectedTask = task
                await this.toggleRemoveTaskDialog()
            },
            toggleRemoveTaskDialog () {
                this.removeTaskDialog = !(this.removeTaskDialog)
            },
            selectTask (task) {
                this.selectedItem = task
                this.getTask(task.id)
            },
            toggleQuickStatusModal(){
                this.statusUpdateDialog = !this.statusUpdateDialog
                if(!this.statusUpdateDialog)
                    this.getRoute(this.route.id)
            }
        },
        computed: {
            ...mapGetters({
                headers: 'routes/detailsHeaders',
                unassignedTasks: 'jobTasks/unassignedTasks',
                userHeaders: 'user/headers',
                users: 'user/users',
                route: 'routes/selectedRoute',
                colorPickerColors: 'routes/colorPickerColors',
                selected: 'jobTasks/selectedJobTask',
                taskNumbersAndAddress: 'jobTasks/taskNumbersAndAddress'
            }),
            usersForDropDown() {
                return this.users.filter(u => {
                    if(u.user.roles && u.user.roles.length > 0) {
                        if(u.user.roles[0].role.id === 1){
                            //Skip any admins (role id 1)
                            return false
                        }
                    }
                    if (!this.userIds.includes(u.user.id)) {
                        if(u.user.firstName){
                            u.user.displayName = u.user.firstName
                        } else if (u.user.lastName) {
                            u.user.displayName = u.user.lastName
                        } else {
                            u.user.displayName = "(No Name)"
                        }
                        return true
                    }
                    return false
                })
            },
            userIds() {
                if (this.route.userRoutes && this.route.userRoutes.length > 0){
                    return this.route.userRoutes.map(userRoute => userRoute.user.id)
                }
                return []
            },
            swatchStyle() {
                const { menu } = this
                return {
                    backgroundColor: this.route.color,
                    cursor: 'pointer',
                    height: '20px',
                    width: '20px',
                    borderRadius: menu ? '50%' : '4px',
                    transition: 'border-radius 200ms ease-in-out'
                }
            },
        },
        watch: {
            showDialog() {
                this.showNameError = false
                if(this.actionType === 'create'){
                    this.tasksToAdd = []
                    this.usersToAdd = []
                }
                this.getNumberAndAddress()
            },
        }
    }
</script>
<style scoped>
    .no-bottom-pad {
        padding-bottom: 0 !important;
    }
    .custom-card-header {
        background-color: #00A5C5;
        color: white;
    }
    .display-flex {
        display: flex;
    }
    .bottom-buttons {
        float: bottom;
        text-align: right;
    }
    .text-center {
        text-align: center;
    }
    .selectedRow {
        background-color: #00C1BE;
        color: white;
    }
</style>
